export class ClassificationWeight {
    id: number;
    positionOne: boolean;
    horse: boolean;

    splitAverageWeight: number;
    catchAverageWeight: number;
    rawActualAverageWeight: number;
    errorAverageWeight: number;

    constructor(positionOne: boolean, horse: boolean) {
        this.positionOne = positionOne;
        this.horse = horse;
    }
}


// WEBPACK FOOTER //
// ./src/model/classification-weight.ts